export const DEFAULT_SLICE_CONFIGURATION_OUTBOUND = {
  slice: {
    expands: {
      expandAll: true,
    },
    rows: [
      {
        uniqueName: 'callDate.Year',
        sort: 'desc',
      },
      { uniqueName: 'branchDescription' },
      {
        uniqueName: 'callDate.Month',
        sort: 'desc',
      },
      {
        uniqueName: 'callDate.Day',
        sort: 'desc',
      },
      { uniqueName: 'userFullName' },
      { uniqueName: 'answered' },
      { uniqueName: 'callOutcome' },
    ],
    columns: [{ uniqueName: 'callHour' }],
    measures: [
      {
        uniqueName: 'callCount',
        aggregation: 'sum',
      },
    ],
  },
};

export const DEFAULT_SLICE_CONFIGURATION_INBOUND = {
  slice: {
    expands: {
      expandAll: true,
    },
    rows: [
      {
        uniqueName: 'callDate.Year',
        sort: 'desc',
      },
      { uniqueName: 'branchDescription' },
      {
        uniqueName: 'callDate.Month',
        sort: 'desc',
      },
    ],
    columns: [{ uniqueName: 'callHour' }],
    measures: [
      {
        uniqueName: 'callCount',
        aggregation: 'sum',
      },
      {
        uniqueName: 'answeredCallCount',
        aggregation: 'sum',
      },
      {
        uniqueName: 'unansweredCallCount',
        aggregation: 'sum',
      },
      {
        uniqueName: 'callUniqueCount',
        aggregation: 'sum',
      },
      {
        uniqueName: 'recalledUniqueCount',
        aggregation: 'sum',
      },
      {
        uniqueName: 'waitingSeconds',
        aggregation: 'avg',
      },
    ],
  },
};

export const DEFAULT_SLICE_APPOINTMENT_PIVOT = {
  slice: {
    expands: {
      expandAll: true,
    },
    rows: [
      {
        uniqueName: 'appointmentDate.Year',
        sort: 'desc',
      },
      { uniqueName: 'branchDescription' },
      {
        uniqueName: 'appointmentDate.Month',
        sort: 'desc',
      },
      {
        uniqueName: 'appointmentDate.Day',
        sort: 'desc',
      },
      { uniqueName: 'userFullName' },
      { uniqueName: 'appointmentOutcome' },
    ],
    columns: [{ uniqueName: 'appointmentHour' }],
    measures: [
      {
        uniqueName: 'count',
        aggregation: 'sum',
      },
    ],
  },
};

export const DEFAULT_SLICE_REDEMPTION_PIVOT = {
  slice: {
    expands: {
      expandAll: true,
    },
    rows: [
      {
        uniqueName: 'dateLoadingPractice.Day',
      },
      {
        uniqueName: 'branchDescription',
      },
      {
        uniqueName: 'userFullName',
      },
    ],
    columns: [
      {
        uniqueName: 'Measures',
      },
      {
        uniqueName: 'practiceState',
      },
    ],
    measures: [
      {
        uniqueName: 'practiceNumber',
        aggregation: 'count',
        availableAggregations: ['count', 'distinctcount'],
      },
    ],
  },
};

export const getMetadataRedemption = (intl) => ({
  branchDescription: { caption: intl.messages.BRANCH, type: 'string' },
  dateLoadingPractice: {
    caption: intl.messages.DATE_LOADING_PRACTICE,
    type: 'date',
  },
  'dateLoadingPractice.Year': { caption: intl.messages.YEAR, type: 'string' },
  'dateLoadingPractice.Month': { caption: intl.messages.MONTH, type: 'month' },
  'dateLoadingPractice.Day': { caption: intl.messages.DAY, type: 'number' },
  userFullName: { caption: intl.messages.OPERATOR, type: 'string' },
  practiceState: { caption: intl.messages.PRACTICE_STATE, type: 'string' },
  practiceNumber: { caption: intl.messages.PRACTICE_NUMBER, type: 'string' },
  loanPurpose: { caption: intl.messages.LOANPURPOSE, type: 'string' },
  leadSource: { caption: intl.messages.LEADSOURCE, type: 'string' },
  callNum: { caption: intl.messages.CALLS, type: 'number' },
});

export const getMetadataAppointment = (intl) => ({
  branchDescription: { caption: intl.messages.BRANCH, type: 'string' },
  appointmentDate: { caption: intl.messages.APPOINTMENTDATE, type: 'date' },
  'appointmentDate.Year': { caption: intl.messages.YEAR, type: 'string' },
  'appointmentDate.Month': { caption: intl.messages.MONTH, type: 'month' },
  'appointmentDate.Day': { caption: intl.messages.DAY, type: 'number' },
  userFullName: { caption: intl.messages.OPERATOR, type: 'string' },
  appointmentOutcome: { caption: intl.messages.OUTCOME, type: 'string' },
  appointmentHour: { caption: intl.messages.TIME, type: 'time' },
  count: { caption: intl.messages.APPOINTMENTS, type: 'number' },
  week: { caption: intl.messages.WEEK, type: 'number' },
  weekDay: { caption: intl.messages.WEEKDAY, type: 'weekday' },
});

export const getMetadataOutbound = (intl) => ({
  branchDescription: { caption: intl.messages.BRANCH, type: 'string' },
  callDate: { caption: intl.messages.CALLDATE, type: 'date' },
  'callDate.Year': { caption: intl.messages.YEAR, type: 'string' },
  'callDate.Month': { caption: intl.messages.MONTH, type: 'month' },
  'callDate.Day': { caption: intl.messages.DAY, type: 'number' },
  userFullName: { caption: intl.messages.OPERATOR, type: 'string' },
  callOutcome: { caption: intl.messages.OUTCOME, type: 'string' },
  callHour: { caption: intl.messages.TIME, type: 'time' },
  callCount: { caption: intl.messages.OUTBOUND_CALLS, type: 'number' },
  week: { caption: intl.messages.WEEK, type: 'number' },
  weekDay: { caption: intl.messages.WEEKDAY, type: 'weekday' },
  answered: { caption: intl.messages.CALL_ANSWERED, type: 'string' },
  uniqueContacts: { caption: intl.messages.UNIQUE_CONTACTS, type: 'number' },
  uniqueAnsweredContacts: {
    caption: intl.messages.UNIQUE_ANSWERED_CONTACTS,
    type: 'number',
  },
  uniqueUnansweredContacts: {
    caption: intl.messages.UNIQUE_UNANSWERED_CONTACTS,
    type: 'number',
  },
  sectionName: { caption: intl.messages.SECTION_NAME, type: 'string' },
});

export const getMetadataInbound = (intl) => ({
  branchDescription: { caption: intl.messages.BRANCH, type: 'string' },
  callDate: { caption: intl.messages.CALLDATE, type: 'date' },
  'callDate.Year': { caption: intl.messages.YEAR, type: 'string' },
  'callDate.Month': { caption: intl.messages.MONTH, type: 'month' },
  'callDate.Day': { caption: intl.messages.DAY, type: 'number' },
  callOutcome: { caption: intl.messages.OUTCOME, type: 'string' },
  callHour: { caption: intl.messages.TIME, type: 'time' },
  callCount: { caption: intl.messages.INBOUND_CALLS, type: 'number' },
  unansweredCallCount: {
    caption: intl.messages.UNANSWEREDCALLCOUNT,
    type: 'number',
  },
  answeredCallCount: {
    caption: intl.messages.ANSWEREDCALLSCOUNT,
    type: 'number',
  },
  uniqueUnansweredNumbersCount: {
    caption: intl.messages.UNIQUEUNANSWEREDNUMBERSCOUNT,
    type: 'number',
  },
  uniqueRecalledNumbersCount: {
    caption: intl.messages.UNIQUERECALLEDNUMBERSCOUNT,
    type: 'number',
  },
  uniqueRecalledNumbersNotAnsweredCount: {
    caption: intl.messages.UNIQUERECALLEDNUMBERSNOTANSWEREDCOUNT,
    type: 'number',
  },
  uniqueCallAgainAnsweredNumbersCount: {
    caption: intl.messages.UNIQUECALLAGAINANSWEREDNUMBERSCOUNT,
    type: 'number',
  },
  uniqueRemainingUnansweredNumbersCount: {
    caption: intl.messages.UNIQUE_REMAINING_UNANSWERED_NUMBERS,
    type: 'number',
  },
  uniqueUnmanagedUnansweredNumbersCount: {
    caption: intl.messages.UNIQUE_UNMANAGED_UNANSWERED_NUMBERS,
    type: 'number',
  },
  uniqueUnhandlableCallerNumber: {
    caption: intl.messages.UNIQUE_UNHANDLABLE_UNANSWERED_NUMBERS,
    type: 'number',
  },
  waitingSeconds: { caption: intl.messages.WAITING_SECONDS, type: 'number' },
  week: { caption: intl.messages.WEEK, type: 'number' },
  weekDay: { caption: intl.messages.WEEKDAY, type: 'weekday' },

  callHourRange: { caption: intl.messages.CALL_HOUR_RANGE, type: 'string' },
  sourceCallerNumber: {
    caption: intl.messages.SOURCE_CALLER_NUMBER,
    type: 'string',
  },
  fullName: { caption: intl.messages.FULL_NAME, type: 'string' },
  shortAbandonedCallCount: {
    caption: intl.messages.SHORT_ABANDONED_CALL_COUNT,
    type: 'number',
  },
  isShortAbandoned: {
    caption: intl.messages.IS_SHORT_ABANDONED,
    type: 'string',
  }, // String is often safer for booleans in pivot libraries
});

export const DEFAULT_SLICE_TARGET_PIVOT = {
  slice: {
    expands: {
      expandAll: true,
    },
    rows: [
      {
        uniqueName: 'branchDescription',
        sort: 'asc',
      },
      {
        uniqueName: 'sectionName',
      },
    ],
    columns: [
      {
        uniqueName: 'isTarget',
      },
      {
        uniqueName: 'Measures',
      },
    ],
    measures: [
      {
        uniqueName: 'count',
        aggregation: 'sum',
      },
    ],
  },
};

export const getMetadataTargetPivot = (intl) => ({
  branchId: {
    caption: intl.messages.BRANCH_ID || 'Branch ID',
    type: 'string',
  },
  branchDescription: {
    caption: intl.messages.BRANCH || 'Branch',
    type: 'string',
  },
  sectionId: {
    caption: intl.messages.SECTION_ID || 'Section ID',
    type: 'id',
  },
  sectionName: {
    caption: intl.messages.SECTION_NAME || 'Section Name',
    type: 'string',
  },
  isTarget: {
    caption: intl.messages.IS_TARGET || 'Is Target',
    type: 'string', // Depending on the pivot library, booleans often render better as strings (e.g., "true"/"false")
  },
  filterReason: {
    caption: intl.messages.FILTER_REASON || 'Filter Reason',
    type: 'number',
  },
  filterName: {
    caption: intl.messages.FILTER_NAME || 'Filter Name',
    type: 'string',
  },
  count: {
    caption: intl.messages.COUNT || 'Count',
    type: 'number',
  },
});
